/* AURA X24 — JS V2 (CRO patterns) */
(function () {
  const page = document.querySelector('.x24-page');
  if (!page) return;

  /* 1) Galería: thumbs + prev/next */
  const mainImg = page.querySelector('#X24MainImg');
  const thumbs  = page.querySelectorAll('.x24-thumb');
  let idx = 0;

  const setIdx = (i) => {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    thumbs.forEach(t => t.classList.remove('active'));
    thumbs[i].classList.add('active');
    if (mainImg) mainImg.src = thumbs[i].dataset.src;
    idx = i;
  };

  thumbs.forEach((t, i) => t.addEventListener('click', () => setIdx(i)));
  page.querySelector('.x24-prev')?.addEventListener('click', () => setIdx(idx - 1));
  page.querySelector('.x24-next')?.addEventListener('click', () => setIdx(idx + 1));

  /* 2) Selector de color → busca variante real Shopify */
  const colorOpts = page.querySelectorAll('.x24-color-opt');
  const variantInput = page.querySelector('#X24VariantId');
  const productHandle = (location.pathname.match(/products\/([^/]+)/) || [])[1];
  let productData = null;
  if (productHandle) {
    fetch(`/products/${productHandle}.js`).then(r => r.json()).then(d => {
      productData = d;
      updateCartPrice();
    }).catch(()=>{});
  }

  colorOpts.forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.x24-color-options');
      wrapper.querySelectorAll('.x24-color-opt').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const selectedValueSpan = page.querySelector('.x24-selected-value');
      if (selectedValueSpan) selectedValueSpan.textContent = btn.dataset.value;
      if (!productData) return;

      const selected = [];
      page.querySelectorAll('.x24-color-options').forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const active = group.querySelector('.x24-color-opt.active');
        if (active) selected[pos - 1] = active.dataset.value;
      });

      const match = productData.variants.find(v =>
        selected.every((val, i) => v[`option${i + 1}`] === val)
      );
      if (match && variantInput) {
        variantInput.value = match.id;
        updateCartPrice(match.price);
      }
    });
  });

  /* 3) Pack selector → actualiza precio del CTA y sticky con el valor display */
  const cartPriceEl = page.querySelector('#X24CartPrice');
  const stickyPriceEl = document.querySelector('.x24-sticky-price');

  function updateCartPrice() {
    const selected = page.querySelector('.x24-pack-input:checked');
    if (!selected) return;
    const display = selected.dataset.displayPrice;
    if (display && cartPriceEl) cartPriceEl.textContent = display;
    if (display && stickyPriceEl) stickyPriceEl.textContent = display;

    page.querySelectorAll('.x24-pack').forEach(p => p.classList.remove('checked'));
    selected.closest('.x24-pack').classList.add('checked');
  }

  page.querySelectorAll('.x24-pack-input').forEach(input => {
    input.addEventListener('change', updateCartPrice);
  });
  updateCartPrice();

  /* 5) Sticky CTA mobile: aparece al scrollear */
  const sticky = document.querySelector('#X24Sticky');
  const heroCTA = page.querySelector('#x24-buy');
  if (sticky && heroCTA) {
    const onScroll = () => {
      const rect = heroCTA.getBoundingClientRect();
      const buttonOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      sticky.classList.toggle('x24-visible', buttonOutOfView);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 6) Smooth scroll a #x24-buy */
  page.querySelectorAll('a[href="#x24-buy"]').forEach(a => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      page.querySelector('#x24-buy')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
